import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
function _createMdxContent(props) {
  const _components = {
    a: "a",
    br: "br",
    h3: "h3",
    h4: "h4",
    li: "li",
    ol: "ol",
    p: "p",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "주식회사 셀러노트"
      }), " (이하 ‘회사’)은(는) 개인정보보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 수립하여 공개하고 있습니다. 회사는 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다."]
    }), "\n", _jsx(_components.p, {
      children: "최초 제정 2021. 03. 23 (시행 2021.03.23)"
    }), "\n", _jsx(_components.p, {
      children: "최근 개정 2024. 12. 13 (시행 2024.12.20)"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "제1조 (개인정보의 처리목적)"
    }), "\n", _jsx(_components.p, {
      children: "회사는 다음의 목적을 위하여 개인정보를 수집·이용 등 처리하며, 홈페이지, 전화, 이메일, 서면 양식, 팩스, 실시간 상담, 위탁사로부터의 수령 등을 통해 법령이 허용한 범위 내에서 다음의 목적을 위해서만 개인정보를 수집하고, 그 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "제2조 (개인정보의 구체적인 처리목적 및 항목)"
    }), "\n", _jsx(_components.p, {
      children: "회사가 수집하는 개인정보 항목과 이용목적은 다음과 같습니다."
    }), "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "구분"
          }), _jsx(_components.th, {
            children: "수집 항목"
          }), _jsx(_components.th, {
            children: "처리목적"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "홈페이지 또는 앱 회원가입 및 관리"
          }), _jsx(_components.td, {
            children: "이용자 이름, 연락처, 이메일, 사업자 대표자 이름, 연락처, 이메일, 사업자 통장계좌번호, 주소, 팩스번호"
          }), _jsx(_components.td, {
            children: "고객본인확인 및 회원관리홈페이지 사이트 이용을 위한 목적"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "민원(상담, 고충 등) 사무 처리"
          }), _jsx(_components.td, {
            children: "이용자 이름, 연락처, 이메일, 민원내역"
          }), _jsx(_components.td, {
            children: "민원(상담, 고충 등) 사무 처리를 위한 목적"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "고객 관련 업체관리"
          }), _jsx(_components.td, {
            children: "업체 담당자 이름, 연락처, 이메일, 주소"
          }), _jsx(_components.td, {
            children: "고객의 관련 업체(구매처, 납품처, 관세사 등) 등록관리"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "재화 또는 서비스 제공 : 수출입 운송 서비스"
          }), _jsx(_components.td, {
            children: "수출입자 담당자 이름, 연락처, 이메일, 주소, BL, C/I, P/L 등 수출입운송 관련 서류 기재 수출입자, 및 신고인 개인정보(담당자 이름, 연락처, 이메일, 주소)"
          }), _jsx(_components.td, {
            children: "수출입 운송 등 서비스 제공을 위한 목적"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "재화 또는 서비스 제공 : 풀필먼트 출고 서비스"
          }), _jsx(_components.td, {
            children: "발송인 이름, 연락처, 수취인 이름, 연락처, 주소"
          }), _jsx(_components.td, {
            children: "운송 위탁 서비스"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "재화 또는 서비스 제공 : 해외 송금 서비스"
          }), _jsxs(_components.td, {
            children: ["1) 송금인 개인사업자 경우,", _jsx(_components.br, {}), "대표자 이름, 주소, 대표자 고유식별변호(또는 주민번호), 은행계좌번호, (대리업무시) 대리인 이름, 주소, 고유식별번호(또는 주민번호)", _jsx(_components.br, {}), _jsx(_components.br, {}), "2) 송금인 법인경우,", _jsx(_components.br, {}), "대표자 이름, 주소, 대표자 고유식별변호(또는 주민번호), 은행계좌번호, (대리업무시) 대리인 이름, 주소, 고유식별번호(또는 주민번호),(주주명부상)법인 개인 주주 이름, 주소, 고유식별번호(또는 주민번호,(법인등기부상) 법인 임원 이름, 생년월일(또는 주민등록번호)", _jsx(_components.br, {}), _jsx(_components.br, {}), "3) 수취인정보", _jsx(_components.br, {}), "수취인 담당자 이름, 은행계좌번호, 연락처, 이메일, 주소"]
          }), _jsx(_components.td, {
            children: "해외 송금 서비스"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "고객 서비스 통계"
          }), _jsx(_components.td, {
            children: "성명, 이메일, 연락처, 주소"
          }), _jsx(_components.td, {
            children: "고객 서비스 향상을 위한 통계 작성 목적"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "각종 서비스 관련 정보 및 이벤트 정보 안내"
          }), _jsx(_components.td, {
            children: "성명, 이메일, 연락처"
          }), _jsx(_components.td, {
            children: "각종 정보 및 이벤트 관련 사항 소개, 안내, 정보 제공을 위한 목적"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "자동 수집 항목"
          }), _jsx(_components.td, {
            children: "기기정보(운영체제 정보, 디바이스 식별자, 화면사이즈), 방문(접속 로그) 기록, 서비스 이용 기록(부정 사용기록, 거래 기록 포함"
          }), _jsx(_components.td, {
            children: "보안, 프라이버시, 안전, 부정이용 방지, 마케팅 등의 목적 및 개인정보 유효기간제 목적"
          })]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "제3조 (개인정보의 처리 및 보유·이용기간)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "회사는 원칙적으로 이용자의 개인정보를 홈페이지 또는 앱의 이용자 탈퇴시 또는 개인정보 수집 및 이용목적이 달성된 후에는 지체없이 개인정보를 파기합니다. 다만, 법령에 따른 개인정보 보유․이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유․이용기간 내에서 개인정보를 처리․보유합니다."
      }), "\n", _jsx(_components.li, {
        children: "각각의 개인정보 처리 및 보유·이용 기간은 다음과 같습니다."
      }), "\n"]
    }), "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "구분"
          }), _jsx(_components.th, {
            children: "수집 항목"
          }), _jsx(_components.th, {
            children: "보유기간"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "홈페이지 또는 앱 회원가입 및 관리"
          }), _jsx(_components.td, {
            children: "이용자 이름, 연락처, 이메일, 사업자 대표자 이름, 연락처, 이메일, 사업자 통장계좌번호, 주소, 팩스번호"
          }), _jsx(_components.td, {
            children: "회원 탈퇴시까지"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "민원(상담, 고충 등) 사무 처리"
          }), _jsx(_components.td, {
            children: "이용자 이름, 연락처, 이메일, 민원내역"
          }), _jsx(_components.td, {
            children: "회원 탈퇴시까지"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "고객 관련 업체관리"
          }), _jsx(_components.td, {
            children: "업체 담당자 이름, 연락처, 이메일, 주소"
          }), _jsx(_components.td, {
            children: "회원 탈퇴시까지"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "재화 또는 서비스 제공 : 수출입 운송 서비스"
          }), _jsx(_components.td, {
            children: "수출입자 담당자 이름, 연락처, 이메일, 주소, BL, C/I, P/L 등 수출입운송 관련 서류 기재 수출입자, 및 신고인 개인정보(담당자 이름, 연락처, 이메일, 주소)"
          }), _jsx(_components.td, {
            children: "회원 탈퇴시, 혹은 위탁계약 종료시, 단, 관련법령의 별도 규정이 명시되어 있는 경우 그 기간을 따름"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "재화 또는 서비스 제공 : 풀필먼트 출고 서비스"
          }), _jsx(_components.td, {
            children: "발송인 이름, 연락처, 수취인 이름, 연락처, 주소"
          }), _jsx(_components.td, {
            children: "회원 탈퇴시, 혹은 위탁계약 종료시, 단, 관련법령의 별도 규정이 명시되어 있는 경우 그 기간을 따름"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "재화 또는 서비스 제공 : 해외 송금 서비스"
          }), _jsxs(_components.td, {
            children: ["1) 송금인 개인사업자 경우", _jsx(_components.br, {}), "대표자 이름, 주소, 대표자 고유식별변호(또는 주민번호), 은행계좌번호, (대리업무시) 대리인 이름, 주소, 고유식별번호(또는 주민번호)", _jsx(_components.br, {}), _jsx(_components.br, {}), "2) 송금인 법인경우", _jsx(_components.br, {}), "대표자 이름, 주소, 대표자 고유식별변호(또는 주민번호), 은행계좌번호, (대리업무시) 대리인 이름, 주소, 고유식별번호(또는 주민번호),(주주명부상)법인 개인 주주 이름, 주소, 고유식별번호(또는 주민번호,(법인등기부상) 법인 임원 이름, 생년월일(또는 주민등록번호)", _jsx(_components.br, {}), _jsx(_components.br, {}), "3) 수취인정보", _jsx(_components.br, {})]
          }), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "수취인 담당자 이름, 은행계좌번호, 연락처, 이메일, 주소"
          }), _jsx(_components.td, {
            children: "회원 탈퇴시, 혹은 협력계약 종료시, 단, 관련법령의 별도 규정이 명시되어 있는 경우 그 기간을 따름"
          }), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "고객 서비스 통계"
          }), _jsx(_components.td, {
            children: "성명, 이메일, 연락처, 주소"
          }), _jsx(_components.td, {
            children: "회원 탈퇴시까지"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "각종 서비스 관련 정보 및 이벤트 정보 안내"
          }), _jsx(_components.td, {
            children: "성명, 이메일, 연락처"
          }), _jsx(_components.td, {
            children: "회원 탈퇴시까지 또는 제공 안내 동의 철회시"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "자동 수집 항목"
          }), _jsx(_components.td, {
            children: "기기정보(운영체제 정보, 디바이스 식별자, 화면사이즈), 방문(접속 로그) 기록, 서비스 이용 기록(부정 사용기록, 거래 기록 포함)"
          }), _jsx(_components.td, {
            children: "회원 탈퇴시까지 또는 제공 안내 동의 철회시"
          })]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "제4조 (개인정보의 제3자 제공)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "회사는 정보주체의 개인정보를 본 지침에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 다음과 같이 동의를 거쳐 개인정보를 제3자에게 제공하고 있는 내용은 다음과 같습니다."
      }), "\n"]
    }), "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "구분"
          }), _jsx(_components.th, {
            children: "제공받는 자"
          }), _jsx(_components.th, {
            children: "제공 개인정보 항목"
          }), _jsx(_components.th, {
            children: "제공받는 자의 이용목적"
          }), _jsx(_components.th, {
            children: "제공받는 자의 보유 및 이용기간"
          })]
        })
      }), _jsx(_components.tbody, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "재화 또는 서비스 제공 : 해외 송금 서비스"
          }), _jsx(_components.td, {
            children: "유핀테크허브"
          }), _jsxs(_components.td, {
            children: ["1) 송금인 개인사업자 경우", _jsx(_components.br, {}), "대표자 이름, 주소, 대표자 고유식별변호(또는 주민번호), 은행계좌번호, (대리업무시) 대리인 이름, 주소, 고유식별번호(또는 주민번호)", _jsx(_components.br, {}), _jsx(_components.br, {}), "2) 송금인 법인경우", _jsx(_components.br, {}), "대표자 이름, 주소, 대표자 고유식별변호(또는 주민번호), 은행계좌번호, (대리업무시) 대리인 이름, 주소, 고유식별번호(또는 주민번호),(주주명부상)법인 개인 주주 이름, 주소, 고유식별번호(또는 주민번호,(법인등기부상) 법인 임원 이름, 생년월일(또는 주민등록번호)", _jsx(_components.br, {}), _jsx(_components.br, {}), "3) 수취인정보", _jsx(_components.br, {}), "수취인 담당자 이름, 은행계좌번호, 연락처, 이메일, 주소"]
          }), _jsx(_components.td, {
            children: "해외 송금 서비스 제공"
          }), _jsx(_components.td, {
            children: "회원탈퇴시, 혹은 협력계약 종료시, 단, 관련법령의 별도 규정이 명시되어 있는 경우 그 기간을 따름"
          })]
        })
      })]
    }), "\n", _jsxs(_components.ol, {
      start: "3",
      children: ["\n", _jsxs(_components.li, {
        children: ["다음과 같은 경우에도 회사는 관계법령에 따라 개인정보를 이용, 공개, 제3자에게 양도할 수 있습니다 :\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "거주지 국가 외의 법을 포함하는 관련 법에 의거하여 이용되거나 공개되는 경우"
          }), "\n", _jsx(_components.li, {
            children: "법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우"
          }), "\n", _jsx(_components.li, {
            children: "국가 보안 및/또는 법 집행을 목적으로 거주지 국가 밖의 공공기관 및 정부기관을 포함하는 공공기관 및 정부기관의 요청이 있는 경우"
          }), "\n", _jsx(_components.li, {
            children: "구조조정, 합병, 매각, 합작회사, 양도, 이전 또는 (파산 또는 비슷한 절차와 관련된 것을 포함하여) 회사 전체 또는 일부, 자산 또는 주식에 대한 기타 처분을 하게 되는 경우"
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "제5조 (개인정보 제3자 제공의 예외사항)"
    }), "\n", _jsx(_components.p, {
      children: "회사는 이용자의 개인정보를 개인정보 보호방침 제 1, 2조에 따른 개인정보 수집 범위 및 방법에서 명시한 범위 내에서만 협력업체에게 제공하며 서비스 이용 관련 목적 이 외의 사용 및 타인, 타사에게 제공하지 않습니다. 다만 이용자의 동의 없이 개인정보가 제공될 수도 있는 경우는 아래와 같습니다."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "이용자가 사전에 개인정보를 공개한 경우 (글 등록, 댓글 등의 행위)"
      }), "\n", _jsx(_components.li, {
        children: "관계법령의 규정에 의거 또는 수사 목적으로 수사기관의 요구가 있는 경우"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "제6조 (개인정보처리의 위탁)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "회사는 서비스 제공을 위하여 필요한 업무 중 일부를 외부 업체에 위탁하고 있으며, 위탁받은 업체가 개인정보보호법에 따라 개인정보를 안전하게 처리하도록 필요한 사항을 규정하고 관리/감독하고 있습니다."
      }), "\n", _jsx(_components.li, {
        children: "회사가 수탁업체에 위탁하는 업무와 관련된 서비스를 이용하지 않는 경우, 이용자의 개인정보가 수탁업체에 제공되지 않습니다."
      }), "\n"]
    }), "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "구분"
          }), _jsx(_components.th, {
            children: "업무 목적 및 범위"
          }), _jsx(_components.th, {
            children: "보유 및 이용기간"
          }), _jsx(_components.th, {
            children: "수탁업체"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "결제 처리 서비스"
          }), _jsx(_components.td, {
            children: "비용 결제 처리를 위한 업무(가상계좌)"
          }), _jsx(_components.td, {
            children: "회원 탈퇴시 혹은 위탁 계약 종료시"
          }), _jsx(_components.td, {
            children: "주식회사 핵토파이낸셜"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "재화 또는 서비스 제공 : 수출입 운송 서비스"
          }), _jsx(_components.td, {
            children: "수출입운송 등의 업무"
          }), _jsx(_components.td, {
            children: "회원 탈퇴시 혹은 위탁 계약 종료시"
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://shipda.notion.site/ShipDa-Partner-list-ce50381297de42a39da3cce32216c3e8",
              children: "업체 목록"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "재화 또는 서비스 제공 : 수출입 운송 서비스"
          }), _jsx(_components.td, {
            children: "수출입운송 등의 관세업무"
          }), _jsx(_components.td, {
            children: "회원 탈퇴시 혹은 혹은 위탁 계약 종료시 또는 이용자가 관세사 등록 삭제시"
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://shipda.notion.site/ShipDa-Partner-list-ce50381297de42a39da3cce32216c3e8",
              children: "업체 목록"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "재화 또는 서비스 제공 : 풀필먼트 출고 서비스"
          }), _jsx(_components.td, {
            children: "운송 배송 등의 물류 업무"
          }), _jsx(_components.td, {
            children: "회원 탈퇴시 혹은 위탁 계약 종료시"
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://shipda.notion.site/ShipDa-Partner-list-f4436de96dc74861898fe362a0c69ce2",
              children: "업체 목록"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "웹서버 정보 처리 서비스"
          }), _jsx(_components.td, {
            children: "웹 제공 서비스를 위한 웹 서버 호스팅 운용 및 관리 등에 관련된 업무"
          }), _jsx(_components.td, {
            children: "회원 탈퇴시 혹은 위탁 계약 종료시"
          }), _jsx(_components.td, {
            children: "아마존웹서비시즈코리아 유한책임회사"
          })]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "제7조 (수집한 개인정보의 국외이전)"
    }), "\n", _jsx(_components.p, {
      children: "회사는 아래와 같이 국외 제3자에게 개인정보를 제공하고 있으며 사용자가 거주하는 국가이외의 지역에 있는 서버에서 이용자의 개인정보를 처리할 수 있습니다."
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["이전 받는 업체 및 연락처 리스트 : ", _jsx(_components.a, {
            href: "https://shipda.notion.site/ShipDa-Partner-list-ce50381297de42a39da3cce32216c3e8",
            children: "업체 목록"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "이전 일시 및 방법"
        }), "\n", _jsx(_components.p, {
          children: "홈페이지에서 제공하는 관련 서비스 이용 시점에 네트워크를 통한 전송"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "이전되는 개인정보 항목"
        }), "\n", _jsx(_components.p, {
          children: "제2조 “재화 또는 서비스 제공 : 수출입 운송 서비스” 에 해당하는 수집 항목"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "개인정보를 이전받는 자의 개인정보 이용목적"
        }), "\n", _jsx(_components.p, {
          children: "제2조 내에 명시된 서비스들을 원활하게 제공하기 위해 개인정보를 이전하고 있으며, 이전 업체가 개인정보보호 관계 법령을 위반하지 않도록 관리‧감독하고 있음."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "개인정보를 이전받는 자의 개인정보 보유ㆍ이용기간"
        }), "\n", _jsx(_components.p, {
          children: "개인정보 수집 및 이용에 관한 동의 후 회원탈퇴시, 혹은 해당 계약해지(종료)시 까지 개인정보를 보유하고 이후 해당 정보를 지체 없이 파기함. 단, 법률에 의해 보존의무가 있는 경우에는 법령이 지정한 일정기간 동안 보존함."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "동의를 거부할 권리 및 동의 거부에 따른 불이익"
        }), "\n", _jsx(_components.p, {
          children: "이용자는 정보 수집을 거부할 권리가 있습니다. 단, 동의를 거부할 경우 서비스가 제한될 수 있음."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "제8조(정보주체의 권리․의무 및 행사방법)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "개인정보 열람요구"
          }), "\n", _jsx(_components.li, {
            children: "오류 등이 있을 경우 정정 요구"
          }), "\n", _jsx(_components.li, {
            children: "삭제요구"
          }), "\n", _jsx(_components.li, {
            children: "처리정지 요구"
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.li, {
        children: "제1항에 따른 권리 행사는 회사에 대해 서면, 전화, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체 없이 조치하여야 합니다."
      }), "\n", _jsx(_components.li, {
        children: "정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다."
      }), "\n", _jsx(_components.li, {
        children: "제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다."
      }), "\n", _jsx(_components.li, {
        children: "정보주체는 개인정보 보호법 등 관계법령을 위반하여 회사가 처리하고 있는 정보주체 본인이나 타인의 개인정보 및 사생활을 침해하여서는 아니 됩니다."
      }), "\n", _jsx(_components.li, {
        children: "개인정보 열람 및 처리정지 요구는 개인정보보호법 제35조 제5항, 제37조 제2항에 의하여 정보주체의 권리가 제한될 수 있습니다."
      }), "\n", _jsx(_components.li, {
        children: "개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다."
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "제9조 (개인정보의 파기)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다."
      }), "\n", _jsx(_components.li, {
        children: "정보주체로부터 동의 받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다."
      }), "\n", _jsxs(_components.li, {
        children: ["개인정보 파기의 절차, 기한 및 방법은 다음과 같습니다.\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "파기절차\n이용자가 입력한 정보는 목적 달성 후 내부 방침 및 기타 관련 법령에 따라 일정기간 저장 또는 즉시 파기됩니다."
          }), "\n", _jsxs(_components.li, {
            children: ["파기기한\n", _jsxs(_components.ul, {
              children: ["\n", _jsx(_components.li, {
                children: "이용자 개인정보의 보유기간이 경과된 경우 : 보유기간의 종료일로부터 5일 이내"
              }), "\n", _jsx(_components.li, {
                children: "이용자의 개인정보가 불필요하게 되었을 경우 (개인정보의 처리 목적 달성, 서비스의 폐지, 사업의 종료 등) : 개인정보가 불필요한 것으로 인정되는 날로부터 5일 이내"
              }), "\n"]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["파기방법\n", _jsxs(_components.ul, {
              children: ["\n", _jsx(_components.li, {
                children: "전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 파기합니다."
              }), "\n", _jsx(_components.li, {
                children: "종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다."
              }), "\n"]
            }), "\n"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "제10조 (개인정보 자동수집 장치(쿠키)의 설치, 운영 및 그 거부에 관한 사항)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "회사는 회원에게 특화된 맞춤 서비스를 제공하기 위해서 ‘쿠키(cookie)’ 등을 이용합니다."
      }), "\n", _jsx(_components.li, {
        children: "쿠키란 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에 보내는 작은 텍스트 파일로서 이용자의 컴퓨터 하드디스크에 저장되기도 합니다. 회사는 접속 빈도나 방문 시간 등을 분석, 회원의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여 정보 및 방문 회수 파악 등을 통한 타겟 마케팅을 위하여 쿠키를 사용합니다."
      }), "\n", _jsx(_components.li, {
        children: "회원은 쿠키 설치에 대한 선택권을 가지고 있으며 회원은 모바일 어플리케이션 또는 웹브라우저에서 옵션을 설정함으로써 쿠키를 허용하거나, 모든 쿠키의 저장을 거부할 수도 있습니다. 단, 저장을 거부하는 경우 로그인이 필요한 서비스 이용에 어려움이 있을 수 있습니다."
      }), "\n", _jsx(_components.li, {
        children: "쿠키 설정 거부 방법 예: 쿠키 설정을 거부하는 방법으로는 회원이 사용하는 모바일 어플리케이션 또는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다."
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "제11조 (행태정보의 수집, 전송)"
    }), "\n", _jsx(_components.p, {
      children: "정보주체가 당사 웹사이트 방문 시 웹로그 분석 툴을 통하여 정보주체의 행태정보가 구글 등 웹로그 분석 툴 제공업체에 자동 수집, 전송될 수 있습니다."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "제12조 (개인정보의 안전성 확보조치)"
    }), "\n", _jsx(_components.p, {
      children: "회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다."
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["관리적 조치\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "내부관리계획 수립․시행"
          }), "\n", _jsx(_components.li, {
            children: "정기적 직원 교육 등"
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["기술적 조치\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "개인정보처리시스템 등의 접근권한 관리"
          }), "\n", _jsx(_components.li, {
            children: "접근통제시스템 설치"
          }), "\n", _jsx(_components.li, {
            children: "고유식별정보 등의 암호화"
          }), "\n", _jsx(_components.li, {
            children: "보안프로그램 설치"
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["물리적 조치\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "전산실, 자료보관실 등의 접근통제"
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "제13조(개인정보 보호책임자 등)"
    }), "\n", _jsx(_components.p, {
      children: "회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 열람청구, 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자 및 담당부서를 지정하고 있습니다."
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["개인정보 보호 책임자\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "성명 : 김종하"
          }), "\n", _jsx(_components.li, {
            children: "직책 : CTO"
          }), "\n", _jsxs(_components.li, {
            children: ["연락처 : 1544-7789, ", _jsx(_components.a, {
              href: "mailto:jongha.kim@ship-da.com",
              children: "jongha.kim@ship-da.com"
            })]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["개인정보 보호 담당자\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "성명 : 박진규"
          }), "\n", _jsx(_components.li, {
            children: "직책 : 팀장"
          }), "\n", _jsxs(_components.li, {
            children: ["연락처 : 1544-7789, ", _jsx(_components.a, {
              href: "mailto:innfi@ship-da.com",
              children: "innfi@ship-da.com"
            })]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "정보주체께서는 회사의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 상담 및 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "제14조(정보주체의 권익침해에 대한 구제방법)"
    }), "\n", _jsx(_components.p, {
      children: "정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다."
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["개인정보분쟁조정위원회 : (국번없이) 1833-6972 (", _jsx(_components.a, {
          href: "http://www.kopico.go.kr",
          children: "www.kopico.go.kr"
        }), ")"]
      }), "\n", _jsx(_components.li, {
        children: "개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)"
      }), "\n", _jsxs(_components.li, {
        children: ["대검찰청 : (국번없이) 1301 (", _jsx(_components.a, {
          href: "http://www.spo.go.kr",
          children: "www.spo.go.kr"
        }), ")"]
      }), "\n", _jsx(_components.li, {
        children: "경찰청 : (국번없이) 182 (ecrm.cyber.go.kr)"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h4, {
      children: "개인정보 처리방침의 변경에 관한 사항은 아래에서 확인하실 수 있습니다."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["2021.03.23 ~ 2023.09.03 적용 ", _jsx(_components.a, {
          href: "/policy/privacy/210323",
          children: "링크"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["2023.09.04 ~ 2024.02.28 적용 ", _jsx(_components.a, {
          href: "/policy/privacy/230904",
          children: "링크"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["2024.02.29 ~ 2024.12.19 적용 ", _jsx(_components.a, {
          href: "/policy/privacy/240229",
          children: "링크"
        })]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
